import { useCallback, useEffect, useMemo } from 'react'
import { useInView } from 'react-intersection-observer'

import { useTable } from '../../../../app/hooks/useTable'

export const useTablePageController = () => {
  const { ref, inView } = useInView()

  const {
    data: allData,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    isLoading,
    setParams,
    params,
  } = useTable({ type: 'FGTS' })

  const data = useMemo(() => {
    if (!allData) return undefined

    return {
      ...allData,
      pages: allData.pages.map((page) => ({
        ...page,
        tables: page.tables.filter((table) => {
          const code = parseFloat(table.tableCode)
          return !isNaN(code) && code >= 0
        }),
      })),
    }
  }, [allData])

  const setSkip = useCallback(
    (value: number) => {
      setParams((state) => ({ ...state, skip: value }))
    },
    [setParams],
  )

  useEffect(() => {
    if (inView) {
      fetchNextPage()
    }
  }, [fetchNextPage, inView])

  return {
    setSkip,
    data,
    isFetching,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    ref,
    params,
  }
}
